import { ReactNode } from "react";
import { Button, Snackbar } from "@material-ui/core";
import Alert, { TAlertType } from "./Alert";
import { lang } from "../../../i18nLang";

interface IProps {
  onClose: Function;
  autoHideDuration?: number;
  message: ReactNode;
  onClickButton: Function;
  buttonLabel: string;
  type: TAlertType | "default";
  [property: string]: any;
}

const MessageSnackButton = ({
  onClose,
  message,
  type,
  buttonLabel,
  ...props
}: IProps) => {
  const isDefault = type === "default";

  const handleClose = (ev, reason) => {
    if (reason === "clickaway") return;
    onClose(ev);
  };

  const handleClickConfirm = (ev) => {
    props.onClickButton();
    onClose(ev);
  };

  const actionRender = () => (
    <>
      <Button size="small" onClick={(ev) => handleClickConfirm(ev)}>
        {buttonLabel || lang("close")}
      </Button>
    </>
  );

  if (isDefault)
    return (
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        {...props}
        onClose={handleClose}
        action={actionRender()}
        message={message}
      />
    );

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      {...props}
      onClose={handleClose}
    >
      <Alert icon={false} type={type} action={actionRender()}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default MessageSnackButton;
